import { gql } from "apollo-boost"

export const GET_PROJECT_BENEFICIARIES_BY_PROJECT = gql`
  query ProjectBeneficiariesByProject ($id:ID!) {
    ProjectBeneficiariesByProject (id: $id){
      id
      name
      curp
      phone
      folio
      state
      gender
      colony
      lastName
      birthdate
      maidenName
      municipality
      beneficiary {
        id
        name
        specificObjectives {
          id
          description
          orderIndex
        }
      }
      projectAssistantId
    }
  }
`